import React, { Component } from 'react';
import { connect } from 'react-redux'
import Header from './../../components/header'
import { permissions } from './../../constants'
import handlePermission from './../../containers/app/handlePermission'
import ListShipper from './components/list-shipper'

class SwitchShipper extends Component {
    constructor(props) {
        super(props)
        this.state = {
            currentShipper: null
        }
    }

    handleCurrentShipper = (value) => {
        value = !value ? 'NULL' : value
        this.setState({
            currentShipper: value
        })
    }

    render() {
        let isShowMenuNormal = true;
        if (handlePermission(permissions.SwitchShipper)) {
            isShowMenuNormal = this.state.currentShipper !== 'NULL' ? true : false;
        }

        return (
            <div id='switch-shipper'>
                <Header currentShipper={this.state.currentShipper} isShowMenuNormal={isShowMenuNormal} />
                <ListShipper handleCurrentShipper={this.handleCurrentShipper} />
            </div>
        );
    }
}


export default SwitchShipper



// WEBPACK FOOTER //
// ./src/containers/switch-shipper/index.js